<template>
  <div id="screen" class="ui center aligned basic segment" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3 class="header">Start offline inspection</h3>
      <div class="ui left aligned basic segment">
        <form class="ui form" id="insform" @submit="onOLFormSubmit">
          <h4 class="ui dividing header">Basic data</h4>
          <div class="field">
            <label>Registration:</label>
            <input type="text" name="reg" required v-model="reg" :readonly="this.reghidden" :class="{'ui disabled input':this.reghidden}">
          </div>
          <div class="two fields">
            <div class="field">
              <div class="field">
                <label>Fuel</label>
                <select id="fuellevel" name="fuellevel">
                  <option value="E">Empty</option>
                  <option value="1/8">1/8</option>
                  <option value="1/4">1/4</option>
                  <option value="3/8">3/8</option>
                  <option value="1/2">1/2</option>
                  <option value="5/8">5/8</option>
                  <option value="3/4">3/4</option>
                  <option value="7/8">7/8</option>
                  <option value="F">Full</option>
                </select>
              </div>
            </div>
            <div class="field">
              <div class="field">
                <label>Mileage</label>
                <input type="number" id="mileage" name="mileage" required>
              </div>
            </div>
          </div>
          
          <div class="field">
            <label>Is the vehicle clean?</label>
            <div class="two fields">
              <div class="field">
                <label>Inside</label>
                <select id="insideclean" name="insideclean">
                  <option value="clean">Clean</option>
                  <option value="dust">Light dust</option>
                  <option value="small">Small cleaning required</option>
                  <option value="medium">Medium cleaning required</option>
                  <option value="dirty">Full cleaning required</option>
                </select>
              </div>
              <div class="field">
                <label>Outside</label>
                <select id="outsideclean" name="outsideclean">
                  <option value="clean">Clean</option>
                  <option value="dust">Light dust</option>
                  <option value="small">Small cleaning required</option>
                  <option value="medium">Medium cleaning required</option>
                  <option value="dirty">Full cleaning required</option>
                </select>
              </div>
            </div>
          </div>
          <div class="three fields">
            <div class="field">
              <label>Number of keys</label>
              <select id="numkeys" name="numkeys">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </div>
            <div class="field">
              <label>Door protectors</label>
              <select id="doorprotectors" name="doorprotectors">
                <option value="na">- not applicable -</option>
                <option value="allgood">all in good condition</option>
                <option value="slightlydamaged">slightly damaged</option>
                <option value="damaged">damaged</option>
                <option value="onemissing">one missing</option>
                <option value="allmissing">all missing</option>
              </select>
            </div>
            <div class="field">
              <label>Umbrellas</label>
              <select id="umbrellas" name="umbrellas">
                <option value="na">- not applicable -</option>
                <option value="0f2">2 umbrellas</option>
                <option value="1f2">1 of 2 missing</option>
                <option value="2f2">2 of 2 missing</option>
                <option value="0f4">4 umbrellas</option>
                <option value="1f4">1 of 4 missing</option>
                <option value="2f4">2 of 4 missing</option>
                <option value="3f4">3 of 4 missing</option>
                <option value="4f4">4 of 4 missing</option>
              </select>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Tyres</label>
              <select id="tyres" name="tyres">
                <option value="ok">Ok</option>
                <option value="damaged">Damaged</option>
                <option value="wear">Wear</option>
              </select>
            </div>
            <div class="field">
              <label>Parcel shelf</label>
              <select id="parcelshelf" name="parcelshelf" required>
                <option value="">-- select --</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>
          <div class="three fields">
            <div class="field">
              <label>Glovebox</label>
              <select id="glovebox" name="glovebox">
                <option value="na">- not applicable -</option>
                <option value="hbp">handbook present</option>
                <option value="empty">empty</option>
              </select>
            </div>
            <div class="field">
              <label>Centre console</label>
              <select id="cconsole" name="cconsole">
                <option value="na">- not applicable -</option>
                <option value="empty">empty</option>
                <option value="clean">clean</option>
              </select>
            </div>
            <div class="field">
              <label>Door pockets</label>
              <select id="doorpockets" name="doorpockets">
                <option value="na">- not applicable -</option>
                <option value="clean">empty</option>
              </select>
            </div>
          </div>
          <div class="three fields">
            <div class="field">
              <label>Spare wheel</label>
              <select id="sparewheel" name="sparewheel">
                <option value="na">- not applicable -</option>
                <option value="good">in good condition</option>
                <option value="damaged">damaged</option>
                <option value="missing">missing</option>
              </select>
            </div>
            <div class="field">
              <label>Pump&amp;tyre repair kit</label>
              <select id="pumpngunk" name="pumpngunk">
                <option value="na">- not applicable -</option>
                <option value="allgood">both present</option>
                <option value="onlypump">only pump</option>
                <option value="onlygunk">only tyre repair kit</option>
                <option value="bothmissing">both missing</option>
              </select>
            </div>
            <div class="field">
              <label>Locking wheelnut</label>
              <select id="wheelnut" name="wheelnut">
                <option value="na">- not applicable -</option>
                <option value="present">present</option>
              </select>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Dashboard lights</label>
              <input type="text" name="dashlights" placeholder="Leave blank if no warnings">
            </div>
            <div class="field">
              <label>Any other damage</label>
              <input type="text" name="anyother" placeholder="type here any other damage">
            </div>
          </div>
          <div class="two fields">
            <div class="field" id="locationcntr">
              <label>Location</label>
              <select id="locationselector" v-model="selectedlocation" class="ui dropdown">
                <option value="-1"></option>
                <option v-for="(loc,index) in this.$locations" :key="index" :value="loc.id">{{ loc.companyname }}</option>
              </select>
            </div>
            <div class="field" id="sourceoperator">
              <label>From operator:</label>
              <select id="operatorselector" v-model="selectedoperator" class="ui dropdown" required>
                <option value="">-- Please select --</option>
                <option value="2"> 24x7 Ltd (Group)</option>
                <option value="18">24x7 Bedfordshire</option>
                <option value="7">24x7 Buckinghamshire</option>
                <option value="34">24x7 Cambridge and Suffolk</option>
                <option value="20">24x7 Cheshire</option>
                <option value="26">24x7 Cornwall</option>
                <option value="23">24x7 County Durham</option>
                <option value="40">24x7 Cumbria</option>
                <option value="32">24x7 Derbyshire</option>
                <option value="30">24x7 Devon</option>
                <option value="33">24x7 Dorset</option>
                <option value="24">24x7 East Riding</option>
                <option value="12">24x7 East Sussex</option>
                <option value="35">24x7 Essex</option>
                <option value="28">24x7 Gloucestershire</option>
                <option value="4">24x7 Hampshire</option>
                <option value="3">24x7 Hertfordshire</option>
                <option value="11">24x7 Kent</option>
                <option value="14">24x7 Lancashire</option>
                <option value="36">24x7 Leicestershire</option>
                <option value="8">24x7 Lincolnshire</option>
                <option value="41">24x7 Manchester</option>
                <option value="6">24x7 Norfolk</option>
                <option value="25">24x7 North Yorkshire</option>
                <option value="1">24x7 Northamptonshire</option>
                <option value="15">24x7 Northumberland /Tyne and Wear </option>
                <option value="5">24x7 Nottinghamshire</option>
                <option value="27">24x7 Oxfordshire</option>
                <option value="22">24x7 Shropshire</option>
                <option value="29">24x7 Somerset</option>
                <option value="44">24x7 South Yorkshire</option>
                <option value="13">24x7 Staffordshire</option>
                <option value="39">24x7 Surrey</option>
                <option value="21">24x7 Warwickshire</option>
                <option value="10">24x7 West Sussex</option>
                <option value="43">24x7 West Yorkshire</option>
                <option value="42">24x7 Wiltshire</option>
                <option value="31">24x7 Worcestershire</option>
                <option value="37">24x7 x spare area</option>
                <option value="38">24x7 x Taxi's</option>
                <option value="9">xx 24x7 Support xx</option>
              </select>
            </div>
          </div>
          <h4 class="ui dividing header">Damages</h4>
          <div class="field">
            <label>Short summary</label>
            <input type="text" id="adshort" name="adshort" v-model="adshort">
          </div>
          <div class="field">
            <label>Description</label>
            <textarea id="addesc" name="addesc" v-model="addesc"></textarea>
          </div>
          <div class="field" id="adlocationfield">
            <label>Locations</label>
            <select id="carpartselect" class="ui fluid search dropdown" multiple="" name="carpartselect">
              <option v-for="(p, i) in bodyparts" :key="i" :value="i">{{ p }}</option>
            </select>
            <div style="width:100%;height:auto;overflow:auto;margin-top:1em">
              <svg id="carpartssvg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="isolation:isolate" viewBox="646.47 244.926 572.03 412.574"><defs><clipPath id="_clipPath_QXe5StHOiawSjjngK5L6LTqOMyRs8ijJ"><rect x="646.47" y="244.926" width="572.03" height="412.574"/></clipPath></defs><g clip-path="url(#_clipPath_QXe5StHOiawSjjngK5L6LTqOMyRs8ijJ)">
      
      <path id="bonnet" d=" M 713 378 L 708 419 L 705 423 L 705 479 L 708 484 L 713 525 L 828 525 L 822 490 L 822 411 L 828 378 L 713 378 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="roof" d=" M 1022 393 L 948 396 L 883 393 L 881 427 L 881 479 L 883 511 L 948 508 L 1022 511 L 1017 484 L 1017 419 L 1022 393 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="rearwindowframe" d=" M 1104 378 L 1022 393 L 1017 419 L 1017 484 L 1022 511 L 1104 525 C 1111.069 515.499 1115.413 501.843 1117 484 L 1117 419 C 1116.152 403.804 1111.828 390.147 1104 378 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="boot" d=" M 1146 378 L 1104 378 C 1111.349 389.176 1115.692 402.853 1117 419 L 1117 484 C 1114.692 501.898 1110.369 515.574 1104 525 L 1146 525 L 1152 484 L 1152 419 L 1146 378 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="bumper01_f" d=" M 647.97 373.693 L 648.97 522.693 C 648.97 528.469 656.635 531.616 661.97 531.616 L 661.97 365.693 C 654.442 365.693 647.97 369.59 647.97 373.693 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="grill_f" d=" M 675.97 398.693 L 675.97 498.693 L 697.03 498.693 L 697.03 484.693 C 694.637 484.402 693.294 482.848 692.97 480 L 692.97 416.693 C 693.143 413.78 694.507 412.123 697.03 411.693 L 696.97 398.693 L 675.97 398.693 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="bumper02_f" d=" M 661.97 365.769 L 661.97 530.769 C 661.97 537.319 675.97 537.616 675.97 530.769 L 675.97 365.769 C 675.97 358.969 661.97 358.763 661.97 365.769 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <rect id="headlights_r" x="675.97" y="375.193" width="21" height="23.5" transform="matrix(1,0,0,1,0,0)" fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="2"/>

      <rect id="headlights_l" x="675.97" y="498.693" width="21" height="23.5" transform="matrix(1,0,0,1,0,0)" fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="2"/>

      <path id="foglight_fr" d="M 654.89 375.193 L 657.05 375.193 C 658.662 375.193 659.97 376.501 659.97 378.113 L 659.97 387.273 C 659.97 388.884 658.662 390.193 657.05 390.193 L 654.89 390.193 C 653.279 390.193 651.97 388.884 651.97 387.273 L 651.97 378.113 C 651.97 376.501 653.279 375.193 654.89 375.193 Z" style="stroke:#000000;fill:#FFFFFF;stroke-width:1;stroke-miterlimit:10;"/>

      <path id="foglight_fl" d="M 654.89 507.193 L 657.05 507.193 C 658.662 507.193 659.97 508.501 659.97 510.113 L 659.97 519.273 C 659.97 520.884 658.662 522.193 657.05 522.193 L 654.89 522.193 C 653.279 522.193 651.97 520.884 651.97 519.273 L 651.97 510.113 C 651.97 508.501 653.279 507.193 654.89 507.193 Z" style="stroke:#000000;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;stroke-width:1"/>

      <circle vector-effect="non-scaling-stroke" cx="668.7204844696648" cy="376.94262330827746" r="1.75" fill="rgb(255,255,255)"/>
      <circle vector-effect="non-scaling-stroke" cx="668.7204844696648" cy="424.94262330827735" r="1.75" fill="rgb(255,255,255)"/>
      <circle vector-effect="non-scaling-stroke" cx="668.7204844696648" cy="471.9426233082773" r="1.75" fill="rgb(255,255,255)"/>
      <circle vector-effect="non-scaling-stroke" cx="668.7204844696648" cy="519.9426233082771" r="1.75" fill="rgb(255,255,255)"/>
                
      <path id="taillights_r" d=" M 1163 369.188 L 1163 398.188 L 1190 398.188 L 1190 366.188 L 1180 359.188 L 1163 369.188 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="tailgrill" d=" M 1163 499.188 L 1190 499.188 L 1190 398.188 L 1163 398.188 L 1163 499.188 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="taillights_l" d=" M 1163 529.188 L 1180 537.188 L 1190 531.188 L 1190 499.188 L 1163 499.188 L 1163 529.188 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="bumper02_r" d=" M 1196 359.188 Q 1190.779 359.159 1190 366.188 L 1190 531.188 Q 1191.039 536.94 1196 537.188 Q 1200.961 537.436 1202 531.188 L 1202 366.188 Q 1201.221 359.217 1196 359.188 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="bumper01_r" d=" M 1217 375.188 C 1216.662 369.514 1212.033 366.188 1202 366.188 L 1202 531.188 C 1211.823 531.188 1217 527.83 1217 522.188 L 1217 375.188 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <circle vector-effect="non-scaling-stroke" cx="1196.75" cy="376.93795402914776" r="1.75" fill="rgb(255,255,255)"/>
      <circle vector-effect="non-scaling-stroke" cx="1196.75" cy="424.93795402914765" r="1.75" fill="rgb(255,255,255)"/>
      <circle vector-effect="non-scaling-stroke" cx="1196.75" cy="471.93795402914753" r="1.75" fill="rgb(255,255,255)"/>
      <circle vector-effect="non-scaling-stroke" cx="1196.75" cy="519.9379540291475" r="1.75" fill="rgb(255,255,255)"/>
                
      <path id="foglight_rr" d="M 1208.42 375.188 L 1210.58 375.188 C 1212.192 375.188 1213.5 376.496 1213.5 378.108 L 1213.5 387.268 C 1213.5 388.88 1212.192 390.188 1210.58 390.188 L 1208.42 390.188 C 1206.808 390.188 1205.5 388.88 1205.5 387.268 L 1205.5 378.108 C 1205.5 376.496 1206.808 375.188 1208.42 375.188 Z" style="stroke:#000000;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;stroke-width:1"/>

      <path id="foglight_rl" d="M 1208.42 511.188 L 1210.58 511.188 C 1212.192 511.188 1213.5 512.496 1213.5 514.108 L 1213.5 523.268 C 1213.5 524.88 1212.192 526.188 1210.58 526.188 L 1208.42 526.188 C 1206.808 526.188 1205.5 524.88 1205.5 523.268 L 1205.5 514.108 C 1205.5 512.496 1206.808 511.188 1208.42 511.188 Z" style="stroke:#000000;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;stroke-width:1"/>
      
      <path id="door03_rr" d=" M 944.03 268.426 L 1005 268.426 L 1010 283.426 L 942.03 283.426 L 944.03 268.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="door03_fr" d=" M 827.03 283.426 C 827.91 278.604 829.557 273.594 832 268.426 L 944.03 268.426 L 942.03 283.426 L 827.03 283.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="door03_rl" d=" M 944.03 634 L 1005 634 L 1010 619 L 942.03 619 L 944.03 634 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="door03_fl" d=" M 827.03 619 C 827.91 623.822 829.557 628.832 832 634 L 944.03 634 L 942.03 619 L 827.03 619 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <circle id="tyre_rl" vector-effect="non-scaling-stroke" cx="1051.5295155303352" cy="626.9999999999999" r="30" fill="rgb(255,255,255)" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
              
      <circle id="wheel_rl" vector-effect="non-scaling-stroke" cx="1051.5295155303352" cy="627.0000000000001" r="18" fill="rgb(255,255,255)" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <circle id="tyre_fl" vector-effect="non-scaling-stroke" cx="777.5295155303353" cy="626.9999999999999" r="30" fill="rgb(255,255,255)" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <circle id="wheel_fl" vector-effect="non-scaling-stroke" cx="777.5295155303353" cy="627.0000000000002" r="18" fill="rgb(255,255,255)" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="bumper01_fl" d=" M 736.03 619 L 706.03 619 L 713.03 634 L 732.03 634 L 736.03 619 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="fender02_fl" d=" M 823.807 596 L 805.507 596 C 815.94 606.898 820.098 619.198 823.03 634 L 832.03 634 C 826.803 623.488 824.072 610.831 823.807 596 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      
      <path id="door01_rl" d=" M 944.03 516 L 981.03 516 C 997.707 516.302 1003.238 516.218 1011.03 525 C 1029.024 544.696 1039.681 558.353 1043.03 566 C 1047.273 573.612 1047.263 578.936 1043.03 582 C 1036.683 584.556 1029.338 588.207 1023.03 596 C 1012.634 596 945.677 596 940.03 596 C 939.567 567.4 943.768 540.092 944.03 516 L 944.03 516 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      
      <path id="door01_fl" d=" M 939.835 596 C 939.376 567.411 943.768 540.084 944.03 516 C 911.903 515.207 894.27 517.512 882.03 525 L 830.03 555 C 825.883 569.506 823.807 583.594 823.807 596 C 839.275 596 932.458 596 939.835 596 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="fender01_fl" d=" M 805.507 596 C 809.053 596 816.29 596 823.807 596 C 823.606 583.129 825.684 569.551 830.03 555 C 816.82 558.783 793.183 561.813 759.03 564 C 741.498 566.085 725.508 570.429 711.03 577 L 728.03 579 L 722.03 596 L 751.03 596 Q 762.105 587 778.03 587 C 789.166 587 798.325 589.696 805.507 596 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="fender01_rl" d=" M 1023.03 596 C 1029.341 591.585 1034.781 585 1052.03 585 Q 1069.748 585 1081.03 596 Q 1129.745 596 1133.03 596 L 1135.03 574 L 1147.03 576 C 1149.583 570.734 1145.593 566.411 1135.03 563 L 1110.03 557 L 1071.03 538.592 C 1049.433 525.929 1025.11 518.742 998.03 517 C 1005.662 519.682 1011.338 523.692 1015.03 529 L 1036.03 555 C 1047.056 569.702 1049.409 578.722 1043.03 582 C 1034.729 585.255 1028.518 590.105 1023.03 596 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="window_fl" d=" M 838.03 558 L 936.03 558 L 939.03 520 L 903.03 522 C 893.636 522.974 864.724 538.711 838.03 558 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="window_rl" d=" M 949.03 520 L 948.03 558 L 1029.03 558 C 1014.223 536.332 1007.087 521.693 991.03 521 L 949.03 520 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="window_xl" d=" M 1015.03 523.592 L 1049.03 558 C 1053.194 558.701 1068.204 559.045 1094.03 559 C 1067.272 540.087 1040.949 528.295 1015.03 523.592 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="guard_fl" d=" M 732.03 634 L 739.03 634 Q 746.593 593 778.03 593 Q 809.466 593 816.03 634 L 823.03 634 Q 815.489 587 778.03 587 Q 740.57 587 732.03 634 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="bumper_fl" d=" M 722.03 596 L 751.03 596 C 743.329 602.176 738.599 610.749 736.03 619 L 706.03 619 C 700.415 618.731 696.916 616.858 697.03 614 L 698.03 602 C 698.592 597.643 700.366 595.938 706.03 596 L 722.03 596 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="door02_fl" d=" M 827.03 619 L 942.03 619 C 941.167 612.059 940.15 604.819 940.03 596 L 824.03 596 C 824.192 605.367 825.202 613.044 827.03 619 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="door02_rl" d=" M 940.03 596 L 1023.03 596 C 1017.026 603.52 1013.062 611.078 1010.03 619 L 942.03 619 C 941.246 610.93 939.923 603.274 940.03 596 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="guard_rl" d=" M 1005.03 634 L 1015.03 634 Q 1021.913 592 1052.03 592 Q 1082.146 592 1091.03 634 L 1098.03 634 Q 1089.312 586.239 1052.03 585 C 1029.11 584.238 1013.454 600.581 1005.03 634 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>

      <path id="bumper_rl" d=" M 1094.03 619 L 1144.03 619 C 1147.64 618.837 1149.65 617.18 1150.03 614 L 1150.03 605 C 1150.003 600.154 1145.408 596.205 1139.03 596 L 1081.03 596 C 1087.81 602.699 1092.307 610.942 1094.03 619 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="bumper01_rl" d=" M 1098.03 634 L 1132.03 634 C 1136.193 634 1140.239 630.172 1140.03 626 C 1139.82 621.828 1140.83 619.505 1143.03 619 L 1094.03 619 L 1098.03 634 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      
      <path id="ind_fl" d="M 797.655 578 L 803.405 578 C 804.301 578 805.03 578.728 805.03 579.625 L 805.03 581.375 C 805.03 582.272 804.301 583 803.405 583 L 797.655 583 C 796.758 583 796.03 582.272 796.03 581.375 L 796.03 579.625 C 796.03 578.728 796.758 578 797.655 578 Z" style="stroke:#000000;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;stroke-width:1"/>

       <path id="doorhandle_fl" d="M 916.885 577 L 930.175 577 C 931.198 577 932.03 577.831 932.03 578.855 L 932.03 582.145 C 932.03 583.169 931.198 584 930.175 584 L 916.885 584 C 915.861 584 915.03 583.169 915.03 582.145 L 915.03 578.855 C 915.03 577.831 915.861 577 916.885 577 Z" style="stroke:#000000;stroke-width:1;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;"/>
                
      <path id="doorhandle_rl" d="M 1018.885 577 L 1032.175 577 C 1033.198 577 1034.03 577.831 1034.03 578.855 L 1034.03 582.145 C 1034.03 583.169 1033.198 584 1032.175 584 L 1018.885 584 C 1017.861 584 1017.03 583.169 1017.03 582.145 L 1017.03 578.855 C 1017.03 577.831 1017.861 577 1018.885 577 Z" style="stroke:#000000;stroke-width:1;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;"/>

      <path id="tyre_rr" d=" M 1021.53 275.426 C 1021.53 291.983 1034.972 305.426 1051.53 305.426 C 1068.087 305.426 1081.53 291.983 1081.53 275.426 C 1081.53 258.869 1068.087 245.426 1051.53 245.426 C 1034.972 245.426 1021.53 258.869 1021.53 275.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="wheel_rr" d=" M 1033.53 275.426 C 1033.53 285.36 1041.595 293.426 1051.53 293.426 C 1061.464 293.426 1069.53 285.36 1069.53 275.426 C 1069.53 265.491 1061.464 257.426 1051.53 257.426 C 1041.595 257.426 1033.53 265.491 1033.53 275.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="tyre_fr" d=" M 747.53 275.426 C 747.53 291.983 760.972 305.426 777.53 305.426 C 794.087 305.426 807.53 291.983 807.53 275.426 C 807.53 258.869 794.087 245.426 777.53 245.426 C 760.972 245.426 747.53 258.869 747.53 275.426 Z " fill="rgb(255,255,255)" stroke-width="1" stroke="rgb(0,0,0)"/>
      
      <path id="wheel_fr" d=" M 759.53 275.426 C 759.53 285.36 767.595 293.426 777.53 293.426 C 787.464 293.426 795.53 285.36 795.53 275.426 C 795.53 265.491 787.464 257.426 777.53 257.426 C 767.595 257.426 759.53 265.491 759.53 275.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="bumper01_fr" d=" M 736.03 283.426 L 706.03 283.426 L 713.03 268.426 L 732.03 268.426 L 736.03 283.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="fender01_fr" d=" M 823.807 306.426 L 805.507 306.426 C 815.94 295.528 820.098 283.228 823.03 268.426 L 832.03 268.426 C 826.803 278.938 824.072 291.595 823.807 306.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="door01_rr" d=" M 944.03 386.426 L 981.03 386.426 C 997.707 386.124 1003.238 386.208 1011.03 377.426 C 1029.024 357.73 1039.681 344.073 1043.03 336.426 C 1047.273 328.813 1047.263 323.49 1043.03 320.426 C 1036.683 317.87 1029.338 314.219 1023.03 306.426 C 1012.634 306.426 945.677 306.426 940.03 306.426 C 939.567 335.026 943.768 362.334 944.03 386.426 L 944.03 386.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="door01_fr" d=" M 939.835 306.426 C 939.376 335.015 943.768 362.342 944.03 386.426 C 911.903 387.219 894.27 384.914 882.03 377.426 L 830.03 347.426 C 825.883 332.92 823.807 318.832 823.807 306.426 C 839.275 306.426 932.458 306.426 939.835 306.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="fender02_fr" d=" M 805.507 306.426 C 809.053 306.426 816.29 306.426 823.807 306.426 C 823.606 319.296 825.684 332.875 830.03 347.426 C 816.82 343.643 793.183 340.613 759.03 338.426 C 741.498 336.341 725.508 331.997 711.03 325.426 L 728.03 323.426 L 722.03 306.426 L 751.03 306.426 Q 762.105 315.426 778.03 315.426 C 789.166 315.426 798.325 312.73 805.507 306.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="fender02_rr" d=" M 1023.03 306.426 C 1029.341 310.841 1034.781 317.426 1052.03 317.426 Q 1069.748 317.426 1081.03 306.426 Q 1129.745 306.426 1133.03 306.426 L 1135.03 328.426 L 1147.03 326.426 C 1149.583 331.692 1145.593 336.015 1135.03 339.426 L 1110.03 345.426 L 1071.03 363.834 C 1049.433 376.497 1025.11 383.684 998.03 385.426 C 1005.662 382.744 1011.338 378.734 1015.03 373.426 L 1036.03 347.426 C 1047.056 332.724 1049.409 323.704 1043.03 320.426 C 1034.729 317.171 1028.518 312.321 1023.03 306.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="window_fr" d=" M 838.03 344.426 L 936.03 344.426 L 939.03 382.426 L 903.03 380.426 C 893.636 379.452 864.724 363.715 838.03 344.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="window_rr" d=" M 949.03 382.426 L 948.03 344.426 L 1029.03 344.426 C 1014.223 366.094 1007.087 380.733 991.03 381.426 L 949.03 382.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="window_xr" d=" M 1015.03 378.834 L 1049.03 344.426 C 1053.194 343.724 1068.204 343.381 1094.03 343.426 C 1067.272 362.339 1040.949 374.131 1015.03 378.834 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="guard_fr" d=" M 732.03 268.426 L 739.03 268.426 Q 746.593 309.426 778.03 309.426 Q 809.466 309.426 816.03 268.426 L 823.03 268.426 Q 815.489 315.426 778.03 315.426 Q 740.57 315.426 732.03 268.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="bumper02_fr" d=" M 722.03 306.426 L 751.03 306.426 C 743.329 300.25 738.599 291.677 736.03 283.426 L 706.03 283.426 C 700.415 283.695 696.916 285.568 697.03 288.426 L 698.03 300.426 C 698.592 304.783 700.366 306.488 706.03 306.426 L 722.03 306.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
                
      <path id="door02_fr" d=" M 827.03 283.426 L 942.03 283.426 C 940.842 290.42 940.15 297.607 940.03 306.426 L 824.03 306.426 C 824.192 297.059 825.202 289.382 827.03 283.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="door02_rr" d=" M 940.03 306.426 L 1023.03 306.426 C 1017.026 298.906 1013.062 291.348 1010.03 283.426 L 942.03 283.426 C 941.246 291.496 939.923 299.152 940.03 306.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="guard_rr" d=" M 1005.03 268.426 L 1015.03 268.426 Q 1021.913 310.426 1052.03 310.426 Q 1082.146 310.426 1091.03 268.426 L 1098.03 268.426 Q 1089.312 316.187 1052.03 317.426 C 1029.11 318.188 1013.454 301.845 1005.03 268.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="bumper02_rr" d=" M 1094.03 283.426 L 1144.03 283.426 C 1147.64 283.589 1149.65 285.246 1150.03 288.426 L 1150.03 297.426 C 1150.003 302.272 1145.408 306.221 1139.03 306.426 L 1081.03 306.426 C 1087.81 299.727 1092.307 291.484 1094.03 283.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="bumper01_rr" d=" M 1098.03 268.426 L 1132.03 268.426 C 1136.193 268.426 1140.239 272.254 1140.03 276.426 C 1139.82 280.598 1140.83 282.921 1143.03 283.426 L 1094.03 283.426 L 1098.03 268.426 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="ind_fr" d="M 797.655 324.426 L 803.405 324.426 C 804.301 324.426 805.03 323.698 805.03 322.801 L 805.03 321.051 C 805.03 320.154 804.301 319.426 803.405 319.426 L 797.655 319.426 C 796.758 319.426 796.03 320.154 796.03 321.051 L 796.03 322.801 C 796.03 323.698 796.758 324.426 797.655 324.426 Z" style="stroke:#000000;stroke-width:1;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;"/>
      <path id="doorhandle_fr" d="M 916.885 325.426 L 930.175 325.426 C 931.198 325.426 932.03 324.595 932.03 323.571 L 932.03 320.281 C 932.03 319.257 931.198 318.426 930.175 318.426 L 916.885 318.426 C 915.861 318.426 915.03 319.257 915.03 320.281 L 915.03 323.571 C 915.03 324.595 915.861 325.426 916.885 325.426 Z" style="stroke:#000000;stroke-width:1;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;"/>
      <path id="doorhandle_rr" d="M 1018.885 325.426 L 1032.175 325.426 C 1033.198 325.426 1034.03 324.595 1034.03 323.571 L 1034.03 320.281 C 1034.03 319.257 1033.198 318.426 1032.175 318.426 L 1018.885 318.426 C 1017.861 318.426 1017.03 319.257 1017.03 320.281 L 1017.03 323.571 C 1017.03 324.595 1017.861 325.426 1018.885 325.426 Z" style="stroke:#000000;stroke-width:1;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;"/>
      
      <g transform="translate(-81.0,20.0)"><path id="mirror_r" d="m 916.885,329.926 h 16.29 c 1.023,0 1.855,-0.831 1.855,-1.855 v -7.79 c 0,-1.024 -0.832,-1.855 -1.855,-1.855 h -16.29 c -1.024,0 -1.855,0.831 -1.855,1.855 v 7.79 c 0,1.024 0.831,1.855 1.855,1.855 z" style="stroke: rgb(0, 0, 0); stroke-width: 1; fill: rgb(255, 255, 255); stroke-linecap: square; stroke-miterlimit: 2;"></path>
      </g>
      <g transform="translate(-81.0,230.0)"><path id="mirror_l" d="m 916.885,329.926 h 16.29 c 1.023,0 1.855,-0.831 1.855,-1.855 v -7.79 c 0,-1.024 -0.832,-1.855 -1.855,-1.855 h -16.29 c -1.024,0 -1.855,0.831 -1.855,1.855 v 7.79 c 0,1.024 0.831,1.855 1.855,1.855 z" style="stroke: rgb(0, 0, 0); stroke-width: 1; fill: rgb(255, 255, 255); stroke-linecap: square; stroke-miterlimit: 2;"></path>
      </g>

                
      <circle id="tankflap" vector-effect="non-scaling-stroke" cx="1088.9999999999995" cy="323" r="7" fill="rgb(255,255,255)" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="sunroof" d="M 915.33 415 L 931.67 415 C 939.027 415 945 420.973 945 428.33 L 945 474.67 C 945 482.027 939.027 488 931.67 488 L 915.33 488 C 907.973 488 902 482.027 902 474.67 L 902 428.33 C 902 420.973 907.973 415 915.33 415 Z" style="stroke:#000000;stroke-width:1;fill:#FFFFFF;stroke-linecap:square;stroke-miterlimit:2;"/>
      <path id="windshield" d=" M 883 393 L 828 378 L 822 411 L 822 490 L 828 525 L 883 511 L 881 480 L 881 427 L 883 393 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <g>
        <g>
          <line x1="834" y1="393" x2="834" y2="437" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
          <line x1="834" y1="409" x2="822" y2="421" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
        </g>
        <g>
          <line x1="834" y1="441" x2="834" y2="485" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
          <line x1="834" y1="457" x2="822" y2="469" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
        </g>
      </g>
      <path id="rearwindshield" d=" M 1092 389 L 1073 389 C 1063.413 390.352 1048.09 393.892 1027 399.592 L 1024 417 L 1024 482 L 1027 503 C 1051.057 509.082 1066.4 512.289 1073 512.592 L 1092 512.592 L 1092 389 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <g>
        <line x1="1077" y1="411" x2="1077" y2="454" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
        <line x1="1092" y1="440" x2="1077" y2="425" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      </g>
      <line x1="679" y1="398.693" x2="679" y2="498.693" stroke-width="1" stroke="rgb(0,0,0)"/>
      <line x1="682" y1="498.693" x2="682" y2="398.693" stroke-width="1" stroke="rgb(0,0,0)"/>
      <line x1="685" y1="398.693" x2="685" y2="498.693" stroke-width="1" stroke="rgb(0,0,0)"/>
      <line x1="688" y1="498.693" x2="688" y2="398.693" stroke-width="1" stroke="rgb(0,0,0)"/>
      <line x1="691" y1="398.693" x2="691" y2="498.693" stroke-width="1" stroke="rgb(0,0,0)"/>

      <line x1="694" y1="398.693" x2="694" y2="413" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <line x1="1170" y1="398.188" x2="1170" y2="365.693" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <line x1="1180" y1="398.188" x2="1180" y2="359.188" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <line x1="1170" y1="499.188" x2="1170" y2="532" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <line x1="1180" y1="499.188" x2="1180" y2="537.188" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="daylight_r" d=" M 675.97 375.193 L 697.03 375.188 C 697.492 370.034 694.493 366.904 688 365.769 L 675.97 365.769 L 675.97 375.193 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/>
      <path id="daylight_l" d=" M 675.918 522.193 L 696.977 522.197 C 697.44 527.352 694.44 530.481 687.947 531.616 L 675.918 531.616 L 675.918 522.193 Z " fill="rgb(255,255,255)" vector-effect="non-scaling-stroke" stroke-width="1" stroke="rgb(0,0,0)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/></g></svg>
            </div>
          </div>
          <div class="field">
            <label>Evidence photos</label>
            <input type="file" id="evidence" multiple accept="images/png, image/jpeg">
          </div>
          <div id="eimages" class="ui stackable cards">
            <div v-for="(e,index) in evidences" :key="index" class="card">
              <div class="image">
                <div style="position: absolute;z-index: 0;width: 100%;">
                  <div class="ui right floated mini circular icon button" style="margin-top: 1em;margin-right: 1em;" @click="removeEvidence(index)">
                    <i class="close icon"></i>
                  </div>
                </div>
                <img :src="e.src">
              </div>
            </div>
          </div>
          <div class="field" v-if="this.selectedBodyparts.length==0 && addesc.length==0 && adshort.length==0 /*&& !vcin */&& !vcout" style="margin-top:2em">
            <label>Set good to go?</label>
            <input type="checkbox" name="goodtogo" value="1">
          </div>
          <div class="field" v-if="this.selectedBodyparts.length==0 && addesc.length==0 && adshort.length==0 &&/* !vcin &&*/ !vcout" style="margin-top:2em">
            <label>Set for sale?</label>
            <input type="checkbox" name="setforsale" value="1">
          </div>
          <div class="field" v-if="this.vcin" style="margin-top:3em;margin-bottom:-2em">
            <p>Please note that after saving this inspection, you will be redirected to the vehicle check out.</p>
          </div>
          <div class="field" style="margin-top:3em">
            <input type="submit" value="Save inspection" class="ui primary button">
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="modalcontainer">
    <!-- bodypart dots selector -->
    <div class="ui modal" id="bodypartdotsmodal" style="margin:auto;position:static">
      <div class="header">Select what type of repairs will be carried out</div>
      <div class="content">
        <form id="bodypartdotsform" class="ui form">
          <div class="field">
            <div class="ui checkbox">
              <input type="checkbox" id="bluedot">
              <label>Blue: SMART repair</label>
            </div>
            <div class="ui checkbox">
              <input type="checkbox" id="pinkdot">
              <label>Pink: Dent</label>
            </div>
            <div class="ui checkbox">
              <input type="checkbox" id="yellowdot">
              <label>Yellow: Alloys</label>
            </div>
            <div class="ui checkbox">
              <input type="checkbox" id="reddot">
              <label>Red: Bodyshop</label>
            </div>
            <div class="ui checkbox">
              <input type="checkbox" id="purpledot">
              <label>Purple: Windscreen</label>
            </div>
          </div>
        </form>
      </div>
      <div class="actions">
        <button class="ui primary approve button" @click="closeBodypartsModal">
          Save 
        </button>
      </div>
    </div>
    <!-- /bodypart dots selector -->
  </div>
</template>

<style>
  .ui.fluid.dropdown.hidden {
    display:none;
  }
</style>

<script>

//  import $ from 'jquery';

  class MultiSelectTag  {
      element = null
      options = null
      customSelectContainer = null
      wrapper = null
      btnContainer = null
      body = null
      inputContainer = null
      inputBody = null
      input = null
      customs={shadow: false, rounded:true}
      button = null
      drawer = null
      ul = null
      tagColor
      domParser = new DOMParser()

      constructor(el, customs) {
        var thiz = this;

        this.tagColor = customs.tagColor || {}

        if (customs) this.customs = customs
          this.element = document.getElementById(el)
          this.createElements()
          this.initOptions()
          this.enableItemSelection()
          this.setValues(false)

          this.inputContainer.addEventListener('click', () => {
              if(thiz.drawer.classList.contains('hidden')) {
                  thiz.initOptions()
                  thiz.enableItemSelection()
                  thiz.drawer.classList.remove('hidden')
                  thiz.input.focus()
              }
          })

          this.input.addEventListener('keyup', (e) => {
                  thiz.initOptions(e.target.value)
                  thiz.enableItemSelection()
          })

          this.input.addEventListener('keydown', (e) => {
              if(e.key === 'Backspace' && !e.target.value && thiz.inputContainer.childElementCount > 1) {
                  const child = thiz.body.children[thiz.inputContainer.childElementCount - 2].firstChild
                  const option = thiz.options.find((op) => op.value == child.dataset.value)
                  option.selected = false
                  thiz.removeTag(child.dataset.value)
                  thiz.setValues()
              }
              
          })
          
          window.addEventListener('click', (e) => {   
              if (!thiz.customSelectContainer.contains(e.target)){
                  thiz.drawer.classList.add('hidden')
              }
          });

      }

      createElements() {
          // Create custom elements
          this.options = this.getOptions();
          this.element.classList.add('hidden')
          
          // .multi-select-tag
          this.customSelectContainer = document.createElement('div')
          this.customSelectContainer.classList.add('mult-select-tag')

          // .container
          this.wrapper = document.createElement('div')
          this.wrapper.classList.add('wrapper')

          // body
          this.body = document.createElement('div')
          this.body.classList.add('body')
          if(this.customs.shadow) {
              this.body.classList.add('shadow')
          }
          if(this.customs.rounded) {
              this.body.classList.add('rounded')
          }
          
          // .input-container
          this.inputContainer = document.createElement('div')
          this.inputContainer.classList.add('input-container')

          // input
          this.input = document.createElement('input')
          this.input.classList.add('input')
          this.input.placeholder = `${this.customs.placeholder || 'Search...'}`

          this.inputBody = document.createElement('inputBody')
          this.inputBody.classList.add('input-body')
          this.inputBody.append(this.input)

          this.body.append(this.inputContainer)

          // .btn-container
          this.btnContainer = document.createElement('div')
          this.btnContainer.classList.add('btn-container')

          // button
          this.button = document.createElement('button')
          this.button.type = 'button'
          this.btnContainer.append(this.button)

          const icon = this.domParser.parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="18 15 12 21 6 15"></polyline></svg>`, 'image/svg+xml').documentElement
          this.button.append(icon)


          this.body.append(this.btnContainer)
          this.wrapper.append(this.body)

          this.drawer = document.createElement('div');
          this.drawer.classList.add(...['drawer', 'hidden'])
          if(this.customs.shadow) {
              this.drawer.classList.add('shadow')
          }
          if(this.customs.rounded) {
              this.drawer.classList.add('rounded')
          }
          this.drawer.append(this.inputBody)
          this.ul = document.createElement('ul');
          
          this.drawer.appendChild(this.ul)
      
          this.customSelectContainer.appendChild(this.wrapper)
          this.customSelectContainer.appendChild(this.drawer)

          // Place TailwindTagSelection after the element
          if (this.element.nextSibling) {
              this.element.parentNode.insertBefore(this.customSelectContainer, this.element.nextSibling)
          }
          else {
              this.element.parentNode.appendChild(this.customSelectContainer);
          }
      }

      initOptions(val = null) {
          this.ul.innerHTML = ''
          for (var option of this.options) {
              if (option.selected) {
                  !this.isTagSelected(option.value) && this.createTag(option)
              }
              else {
                  const li = document.createElement('li')
                  li.innerHTML = option.label
                  li.dataset.value = option.value
                  
                  // For search
                  if(val && option.label.toLowerCase().startsWith(val.toLowerCase())) {
                      this.ul.appendChild(li)
                  }
                  else if(!val) {
                      this.ul.appendChild(li)
                  }
              }
          }
      }

      createTag(option) {
        var thiz = this;
          // Create and show selected item as tag
          const itemDiv = document.createElement('div');
          itemDiv.classList.add('item-container');
          itemDiv.style.color = this.tagColor.textColor || '#2c7a7b'
          itemDiv.style.borderColor = this.tagColor.borderColor || '#81e6d9'
          itemDiv.style.background = this.tagColor.bgColor || '#e6fffa'
          const itemLabel = document.createElement('div');
          itemLabel.classList.add('item-label');
          itemLabel.style.color = this.tagColor.textColor || '#2c7a7b'
          itemLabel.innerHTML = option.label
          itemLabel.dataset.value = option.value 
          const itemClose = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="item-close-svg">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>`, 'image/svg+xml').documentElement
   
          itemClose.addEventListener('click', () => {
              const unselectOption = this.options.find((op) => op.value == option.value)
              unselectOption.selected = false
              thiz.removeTag(option.value)
              thiz.initOptions()
              thiz.setValues()
              if (thiz.customs.onRemoved) thiz.customs.onRemoved(option.value);
          })
      
          itemDiv.appendChild(itemLabel)
          itemDiv.appendChild(itemClose)
          this.inputContainer.append(itemDiv)

          if (this.customs.onAdded) this.customs.onAdded(option.value);
      }

      enableItemSelection() {
          // Add click listener to the list items
          for(var li of this.ul.children) {
              li.addEventListener('click', (e) => {
                  this.options.find((o) => o.value == e.target.dataset.value).selected = true
                  this.input.value = null
                  this.initOptions()
                  this.setValues()
                  this.input.focus()
              })
          }
      }

      isTagSelected(val) {
          // If the item is already selected
          for(var child of this.inputContainer.children) {
              if(!child.classList.contains('input-body') && child.firstChild.dataset.value == val) {
                  return true
              }
          }
          return false
      }
      removeTag(val) {
          // Remove selected item
          for(var child of this.inputContainer.children) {
              if(!child.classList.contains('input-body') && child.firstChild.dataset.value == val) {
                  this.inputContainer.removeChild(child)
              }
          }
      }

      setValues(fireEvent=true) {
          // Update element final values
          var selected_values = []
          for(var i = 0; i < this.options.length; i++) {
              this.element.options[i].selected = this.options[i].selected
              if(this.options[i].selected) {
                  selected_values.push({label: this.options[i].label, value: this.options[i].value})
              }
          }
          if (fireEvent && this.customs.onChange) {
              this.customs.onChange(selected_values)
          }
      }
      getOptions() {
          // Map element options
          return [...this.element.options].map((op) => {
              return {
                  value: op.value,
                  label: op.label,
                  selected: op.selected,
              }
          })
      }
  }

  function diff (num1, num2) {
    if (num1 > num2) {
      return num1 - num2
    } else {
      return num2 - num1
    }
  }

  export default {
    data() {
      return {
        adshort:'',
        addesc:'',
        selectedlocation:this.$route.query.location || -1,
        selectedoperator:-1,
        bodyparts: {
          '0':'-- select a body part --',
          'bonnet': 'bonnet',
          'roof':'roof',
          'rearwindowframe': 'rear window frame',
          'boot':'boot',
          'grill_f':'front grill',
          'headlights_r':'right headlights',
          'headlights_l':'Left headlights',
          'foglight_fr':'front right foglight',
          'foglight_fl':'front left foglight',
          'taillights_r':'right taillights',
          'taillights_l':'left taillights',
          'tailgrill':'tailgate',

          'foglight_rr':'rear right foglight',
          'foglight_rl':'rear left foglight',
          
          'door03_rr':'lower part of rear right door',
          'door03_fr':'lower part of front right door',
          'door03_rl':'lower part of rear left door',
          'door03_fl':'lower part of front left door',

          'tyre_rl':'rear left tyre',
          'tyre_fl':'front left tyre',

          'wheel_rl':'rear left wheel',
          'wheel_fl':'front left wheel',
          
          'bumper01_fl':'lower bumper front left side',
          'bumper01_f': 'lower part of front bumper',
          'bumper02_f':'front bumper',
          'bumper01_r':'lower part of rear bumper',
          'bumper02_r':'rear bumper',
          'bumper_rl':'bumper rear left side',
          'bumper01_rl':'lower part of bumper front left side',
          'bumper01_fr':'front right bumper lower part',
       
          'door01_fl':'front left door upper part',
          'door01_rl':'rear left door upper part',
          'door01_rr':'rear right door upper part',
          'door01_fr':'front right door upper part',
          
          'fender01_fl':'front left wing upper part',
          'fender01_rl':'rear left wing upper part',
          'fender01_fr':'upper part of front right wing',
          'fender01_rr':'upper part of rear right wing',

          'fender02_fl':'front left wing lower part',
          'fender02_rl':'rear right wing lower part',
          'fender02_fr':'lower part of front right wing',
          'fender02_rr':'lower part of rear right wing',
          
          'window_fl':'front left window',
          'window_rl':'rear left window',

          'window_xl':'rear left fixed window',
          'guard_fl':'front left guard',
          'bumper_fl':'bumper front left side',
          
          'door02_fl':'front left door middle section',
          'door02_rl':'rear left door middle section',
          
          'guard_rl':'rear left guard',
          'ind_fl':'front left side indicator',
          'doorhandle_fl':'front left door handle',
          'doorhandle_rl':'rear left door handle',
          'mirror_r':'right wing',
          'mirror_l':'left wing',
          'tyre_rr':'rear right tyre',
          'wheel_rr':'rear right wheel',
          'tyre_fr':'front right tyre',
          'wheel_fr':'front right wheel',
          
          
          'window_fr':'front right window',
          'window_rr':'rear right window',
          'window_xr':'rear right fixed window',
          'guard_fr':'front right guard',
          'bumper02_fr':'right side of front bumper',
          
          'door02_fr':'middle section of front right door',
          'door02_rr':'middle section of rear right door',
          
          'guard_rr':'rear right guard',
          'bumper02_rr':'right side of rear bumper',
          'bumper01_rr':'right side of lower rear bumper',
          'ind_fr':'front right indicator',
          'doorhandle_fr':'front right door handle',
          'doorhandle_rr':'rear right door handle',
          'tankflap':'tank flap',
          'sunroof':'sunroof',
          'windshield':'windshield',
          'rearwindshield':'rear windshield',
          'daylight_r':'right daylight',
          'daylight_l':'left daylight'
        },
        cbodypart:null,
        selectedBodyparts:[],
        bodypartdots:{},
        mst:null,
        evidences:[],
        reg:this.$route.query.reg || '',
        reghidden:false,
        vcin:this.$route.query.vcin || null,
        vcout:this.$route.query.vcout || null,
        isswap:(this.$route.query.isswap || 'false')==='true'?true:false
      }
    },
    methods: {
      onOLFormSubmit(e) {
        if (e) e.preventDefault();

        var myFormData = new FormData(document.getElementById('insform'));
        var formDataObj = {};
        myFormData.forEach((value, key) => {
          formDataObj[key] = value;
        });

        formDataObj.reg = formDataObj.reg.toUpperCase().replace(/ /g, '');
        
        formDataObj.selectedoperator = this.selectedoperator;
        
        if (formDataObj.selectedoperator == -1 || formDataObj.selectedoperator == "-1") {
          // not selected
          return false;
        }
        
        if (formDataObj.parcelshelf == "") {
          return false;
        }

        console.log('insform submitted',formDataObj);
        if (this.selectedBodyparts.length>0) {
          formDataObj.damages = this.selectedBodyparts;
        }

        formDataObj.location = this.selectedlocation;
        formDataObj.bodypartdots = this.bodypartdots;

        var eds = document.querySelectorAll('#eimages img');
        var c,w,h,ctx;
        
        for (var i=0; i< eds.length; i++) {
          c = document.createElement('canvas');
          w = eds[i].naturalWidth;
          h = eds[i].naturalHeight;

          if (w>800) {
            //landscape
            w = 800.0/w;
            h *= w;
            w= 800;
          }
          if (h>600) {
            h = 600.0/h;
            w *= h;
            h= 600;
          }
          c.width = w;
          c.height = h;

          ctx = c.getContext('2d');

          ctx.drawImage(eds[i], 0, 0, eds[i].naturalWidth, eds[i].naturalHeight, 0, 0, w, h);

          formDataObj.evidences = formDataObj.evidences || [];
          formDataObj.evidences.push(c.toDataURL('image/jpeg'));
          formDataObj.id = Date.now();
        }
        console.log(this);
        var y;
        
        

        if (this.vcin && this.vcout) {
          // both vcout and vcin filled, let's put the whole swap together and save
          console.log(this.vcin, this.vcout, this.isswap, 'we have both');
          y = localStorage.getItem('vout'+this.vcout);
          y = JSON.parse(y);
          y.inspection = formDataObj;

          // this.$offlineUploader.addItem(this.$host+'/saveswapol', {
          this.$addOfflineItem(this.$host+'/saveswapol', {
            method:'POST',
            headers: {'Content-type':'application/json'},
            mode:'cors',
            credentials:'include',
            body: JSON.stringify({vcin:JSON.parse(localStorage.getItem('vin'+this.vcin)), vcout:y})
          });

          alert('Vehicle swap was saved. Once you\'re online, it will be uploaded.');
          localStorage.removeItem('vin'+this.vcin);
          localStorage.removeItem('vout'+this.vcout);
          this.clearForm()
          this.$router.push('/');
        }
        else if (this.vcin && !this.vcout && !this.isswap) {
          // only vehicle check in
          y = localStorage.getItem('vin'+this.vcin);
          y = JSON.parse(y);
          y.inspection = formDataObj;

//          this.$offlineUploader.addItem(this.$host+'/savevcinol', {
          this.$addOfflineItem(this.$host+'/savevcinol', {
            method:'POST',
            headers: {'Content-type':'application/json'},
            mode:'cors',
            credentials:'include',
            body: JSON.stringify({vcin:y})
          });

          alert('Vehicle check in was saved. Once you\'re online, it will be uploaded.');
          localStorage.removeItem('vin'+this.vcin);
          this.clearForm()
          this.$router.push('/');
        }
        else if (this.vcin && !this.vcout && this.isswap) {
          // we're doing the check in inspection and it is part of a swap
          // save this inspection into the vcin object
          y = localStorage.getItem('vin'+this.vcin);
          y = JSON.parse(y);
          y.inspection = formDataObj;
          localStorage.setItem('vin'+this.vcin, JSON.stringify(y));
          // if we have isswapm we're going to do the vcout too, so let's go there
          this.$router.push({path:'/vehicleout', query:{vcin:this.vcin, isswap:true}});
        }
        else if (!this.vcin && this.vcout) {
          // only taking a car away
          // save it into vcout and save
          console.log(this.vcin, this.vcout, this.isswap, 'only vcout');
          // only vehicle check in
          y = localStorage.getItem('vout'+this.vcout);
          y = JSON.parse(y);
          y.inspection = formDataObj;

          // this.$offlineUploader.addItem(this.$host+'/savevcoutol', {
          this.$addOfflineItem(this.$host+'/savevcoutol', {
            method:'POST',
            headers: {'Content-type':'application/json'},
            mode:'cors',
            credentials:'include',
            body: JSON.stringify({vcout:y})
          });

          alert('Vehicle check out was saved. Once you\'re online, it will be uploaded.');
          localStorage.removeItem('vout'+this.vcout);
          this.clearForm()
          this.$router.push('/');
        }
        else {
          console.log(this.vcin, this.vcout, this.isswap, 'else');
          // this.$offlineUploader.addItem(this.$host+'/saveol', {
            this.$addOfflineItem(this.$host+'/saveol', {
            method:'POST',
            headers: {'Content-type':'application/json'},
            mode:'cors',
            credentials:'include',
            body: JSON.stringify(formDataObj)
          });

          alert('Inspection was saved. Once you\'re online again, it will be uploaded.');
          this.clearForm()
          this.$router.push('/');
        }
      },
      removeEvidence(index) {
        this.evidences.splice(index,1);
      },
      openBodypartsModal() {
        document.getElementById('bodypartdotsform').reset();
        document.getElementById('modalcontainer').style.display='flex';
        document.getElementById('bodypartdotsmodal').classList.add('active');
      },
      closeBodypartsModal() {
        document.getElementById('modalcontainer').style.display='none';
        document.getElementById('bodypartdotsmodal').classList.remove('active');
        var dots={
          bluedot: document.getElementById('bluedot').checked,
          pinkdot: document.getElementById('pinkdot').checked,
          yellowdot: document.getElementById('yellowdot').checked,
          reddot: document.getElementById('reddot').checked,
          purpledot: document.getElementById('purpledot').checked,
        };
        if (dots.bluedot || dots.pinkdot || dots.yellowdot || dots.reddot || dots.purpledot) {
          this.bodypartdots[this.cbodypart] = dots;
        }
      },
      getLocation() {
        var thiz = this;
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((event) =>{
              var i,a,o,op=-1,od,nd;
              
              for (i=0; i< thiz.$locations.length; i++) {
                if (!(thiz.$locations[i].lat)) {
                  continue;
                }

                if (op === -1) {
                  op = i;
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);

                  od = a*a+o*o;
                }
                else {
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);
                  nd = a*a+o*o;

                  if (nd < od) {
                    od=nd;
                    op = i;
                  }
                }
              }
              thiz.selectedlocation = thiz.$locations[op].id;

            },(e)=>{
              console.log(e);
            },{enableHighAccuracy:true}
          );
        } else {
            alert("Your browser doesn't support Geolocation");
        }
      },
      newBodypart(l) {
        console.log('new bodypart',l);
        this.cbodypart = l;
        this.selectedBodyparts.push(l);
        var el = document.getElementById(l);
        if (el) {
          el.style.fill = 'rgb(255,230,230)';
        }
        // open dot selection dialog
        this.openBodypartsModal();
      },
      bodypartRemoved(l) {
        console.log('removed bodypart',l);
        var a = this.selectedBodyparts.indexOf(l);
        if (a>-1) this.selectedBodyparts.splice(a,1);
        var el = document.getElementById(l);
        if (el) {
          el.style.fill = 'rgb(255,255,255)';
        }
      },
      clearForm() {
        document.getElementById('insform').reset();
        for (var i=0; i< this.selectedBodyparts.length;) {
          this.bodypartRemoved(this.selectedBodyparts[0]);
        }
        this.bodypartdots = {};
        this.evidences = [];
      }
    },
    mounted() {
      var thiz = this;

      if (this.selectedlocation === -1) this.getLocation();

      this.mst = new MultiSelectTag('carpartselect', {
        shadow: false,
        rounded:true,
        onAdded:(l)=>{
          thiz.newBodypart(l)
        },
        onRemoved:(l)=>{
          thiz.bodypartRemoved(l);
        }
      });

      document.querySelector('#carpartssvg').addEventListener('click', (e)=>{
        var id = e.target.getAttribute('id');
        if (!id) return;
        var a = thiz.selectedBodyparts.indexOf(id);
        if (a>-1) {
          thiz.selectedBodyparts.splice(a,1);
          // already selected -> remove from selected
          const option = thiz.mst.options.find((op) => op.value == id)
          option.selected = false
          thiz.mst.removeTag(id)
          thiz.mst.setValues()
          e.target.style.fill = 'rgb(255,255,255)';
        }
        else {
//          thiz.selectedBodyparts.push(id);
          // add to multiselect
          const option = thiz.mst.options.find((op) => op.value == id)
          option.selected = true
          thiz.mst.setValues()
          thiz.mst.createTag(option)
          e.target.style.fill = 'rgb(255,230,230)';
        }
      })

      setTimeout(()=>{
        var tr = thiz.$route.query.reg || '';
        if (tr && tr.length>0) {
          thiz.reghidden = true;
        }
      },250)

      console.log('isswap:', this.isswap);

      //document.getElementById('insform').addEventListener('submit', )

      document.getElementById('evidence').addEventListener('change', ()=>{
        var files = document.getElementById('evidence').files;
        var i;

        for (i=0; i<files.length; i++) {
          var reader = new FileReader();
          reader.onload = function (e) {
            thiz.evidences.push({src:e.target.result});
          }

          reader.readAsDataURL(files[i]);
        }

        document.getElementById('evidence').value='';
      });
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);
    }
  }

</script>
